<template>
  <div>
    <div class="js-app-inner-content" :id="wid"></div>
  </div>
</template>
<script>
import WidgetUtils from '../utils/WidgetUtils';
export default {
  props: ['script', 'extras'],
  data () {
    return {
      wid: WidgetUtils.generateID()
    }
  },
  mounted: function () {
    var self = this
    var targetEl = document.querySelector('body')
    if (self.extras && self.extras != '') {
      var extrasList = self.extras.split(',')
      for (var i = 0; i < extrasList.length; i++) {
        var supportScript = document.createElement('script')
        supportScript.setAttribute('src', extrasList[i])
        targetEl.appendChild(supportScript)
      }
    }
    var scriptTag = document.createElement('script')
    scriptTag.setAttribute('src', self.script)
    targetEl.appendChild(scriptTag)
    var scriptTag2 = document.createElement('script')
    var command = self.script.split('/').reverse()[0].split('.js')[0]
    scriptTag2.innerHTML = 'function fun_'+self.$data.wid+'(){try {' + command + '("' + self.$data.wid + '");}catch(err) {setTimeout(fun_'+self.$data.wid+', 1000);}}fun_'+self.$data.wid+'();'
    targetEl.appendChild(scriptTag2)
  }
}
</script>
<style lang="scss" scoped>
div.js-app-inner-content{
  width:100%;
  height:100%;
}
</style>



// WEBPACK FOOTER //
// src/components/widgets/JSAppWidget.vue